import { render } from "./AppRepairs.vue?vue&type=template&id=65dc0e96"
import script from "./AppRepairs.vue?vue&type=script&lang=js"
export * from "./AppRepairs.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__